import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LancamentoAnexoOnline } from '../interfaces/lancamento-anexo-online';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class LancamentoAnexoOnlineService {

  readonly path = '/lancamento/anexo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  getLancamentoAnexo(id: number, generatePresignedUrl = false){
    return this.http.get<LancamentoAnexoOnline>(`${this.jwtAuthService.apiUrl+ this.path}/${id}?generatePresignedUrl=${generatePresignedUrl}`); 
  }

  getLancamentoAnexoOnlinePage(controle: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<LancamentoAnexoOnline>> {
    return this.http.get<PageResult<LancamentoAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?page=${page}&size=${size}&controle=${controle}&order=${order}&direction=${direction}`);
  }

  getLancamentoAnexoOnlinePageSearch(search:string, controle: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<LancamentoAnexoOnline>> {
    return this.http.get<PageResult<LancamentoAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?search=${search}&page=${page}&size=${size}&controle=${controle}&order=${order}&direction=${direction}`);
  }

  downloadAnexo(anexoId: number ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/download/${anexoId}`
    , {responseType: 'arraybuffer'});
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}

